import styled from "@emotion/styled";

export const Main = styled.div`
display:flex;
flex-direction:column;
overflow:scroll;
background-color:#EFEFEF;
height:100vh;
width:100vw;
`